import React from "react";
import get from "lodash/get";
import { StoryCard, StoryCardSimple, StoryCardBgImage } from "../basic/story-card.js";
import { Carousel } from "../basic/carousel.js";
import { wrapCollectionLayout } from "@quintype/components";
import { Link } from "@quintype/components";
import "./two-col-carousel.module.css";
import { CollectionName } from "../basic/collection-name.js";
import { getNumberOfStoriesToShow, isExternalStory } from "../../utils";

function CarouselTemplate({ story }) {
  return <StoryCard story={story} config={{ image: true, imageAspectRatio: [16, 9] }} />;
}

function TwoColCarouselBase({ stories = [], associatedMetadata = {}, metadata = {}, collection = {}, config = {} }) {
  const configClone = Object.assign({}, config, { image: true, imageAspectRatio: [16, 9] });
  const configCloneForBgImg = Object.assign({}, config, { image: true, imageAspectRatio: [4, 3] });
  const cardStoryCount = 2;
  const originalStoryCount = stories.length;
  if (originalStoryCount < 3) {
    return (
      <div data-comment="At least three stories required for a TwoColCarousel">
        At least three stories required for a TwoColCarousel
      </div>
    );
  }

  let carouselStoryCount = getNumberOfStoriesToShow(metadata.numberOfStoriesInCarousel);
  if (originalStoryCount < carouselStoryCount + cardStoryCount) {
    carouselStoryCount = originalStoryCount - cardStoryCount;
  }
  const { show_collection_title: collectionName = true } = associatedMetadata;

  return (
    <div styleName="wrapper" data-test-id="two-col-carousel-component">
      <div styleName="collection-name-wrapper">
        {collectionName ? <CollectionName name={collection.name} type="large" section={collection} /> : null}
      </div>
      <div styleName="container">
        <div styleName="carousel fix-height">
          <Carousel
            stories={stories.slice(0, carouselStoryCount)}
            limit={carouselStoryCount}
            infinite={carouselStoryCount > 1}
            itemTemplate={CarouselTemplate}
            dots={false}
            config={config}
            collection={collection}
            arrows={carouselStoryCount > 1}
            autoplay={metadata.scrollSpeedMs != 0}
            associatedMetadata={associatedMetadata}
            autoplaySpeed={metadata.scrollSpeedMs}
            rtl={get(config, ["theme-attributes", "language_direction"]) === "right"}
            numberOfStoriesToShow={carouselStoryCount}
          />
        </div>

        <div styleName={`story-with-card fix-height`}>
          <Link
            href={`/${stories[carouselStoryCount].slug}`}
            externalLink={isExternalStory(stories[carouselStoryCount])}
            className="story-card-link"
          >
            <StoryCardSimple
              config={configClone}
              story={stories[carouselStoryCount]}
              hideAuthor={true}
              sectionInlineStyle={{ border: "none" }}
              widths={[250, 480, 640]}
              sizes="(max-width: 500px) 98%, (max-width: 768px) 48%, 23%"
            />
          </Link>
        </div>

        <div styleName={`story-on-image fix-height`}>
          <Link
            href={`/${stories[carouselStoryCount + 1].slug}`}
            externalLink={isExternalStory(stories[carouselStoryCount + 1])}
            className="story-card-link"
          >
            <StoryCardBgImage
              story={stories[carouselStoryCount + 1]}
              hideAuthor={true}
              config={configCloneForBgImg}
              sectionInlineStyle={{ border: "none" }}
              widths={[250, 480, 640]}
              sizes="(max-width: 500px) 98%, (max-width: 768px) 48%, 23%"
            />
          </Link>
        </div>
      </div>
    </div>
  );
}

export const TwoColCarousel = wrapCollectionLayout(TwoColCarouselBase);
